import {Customer,} from '../types';
import {
    SimplePageContentWrapper,
    TabbedComponent,
    TabComponentTab,
} from "@flexinet/ui-components";
import {
    Grid,
    Group,
    Stack
} from "@mantine/core";
import {IndexPage as OrdersPage} from "../../orders/pages/IndexPage.tsx";
import {IndexPage as SubscriptionsPage} from "../../subscriptions/pages/IndexPage.tsx";
import {IndexPage as PaymentProfilesPage} from "../../payment-profiles/pages/IndexPage.tsx";

import {MetadataPropertyCard} from "./MetadataPropertyCard.tsx";
import {InformationPropertyCard} from "./InformationPropertyCard.tsx";
import {ContactInfoPropertyCard} from "./ContactInfoPropertyCard.tsx";
import {CurrentInvoiceWidget} from "./CurrentInvoiceWidget.tsx";
import {LastPaymentWidget} from "./LastPaymentWidget.tsx";
import {BillingInfoPropertyCard} from "./BillingInfoPropertyCard.tsx";
import {BillingProviderManagement} from "./BillingProviderManagement.tsx";
import { useState } from 'react';


export const Profile = ({record, onRecordUpdate}: { record: Customer, onRecordUpdate?: (updates: Partial<Customer>) => void }) => {
    const [currentCustomer, setCurrentCustomer] = useState(record);

    const handleCustomerUpdate = (updatedCustomer: Customer) => {
        setCurrentCustomer(updatedCustomer);
        if (onRecordUpdate) {
            onRecordUpdate(updatedCustomer);
        }
    };

    const tabs = [
        {
            title: 'Overview',
            component: (
                <Stack gap={'xl'}>
                    <SimplePageContentWrapper>
                        <Group grow gap={'xl'}>
                            <CurrentInvoiceWidget record={currentCustomer}/>
                            <LastPaymentWidget record={currentCustomer}/>
                        </Group>
                    </SimplePageContentWrapper>
                    <SubscriptionsPage/>
                </Stack>),
        },
        {
            title: 'Orders',
            component: <OrdersPage/>,
        },
        {
            title: 'Payment Profiles',
            component: <PaymentProfilesPage/>,
        },
        {
            title: 'Billing Provider',
            component: <BillingProviderManagement customer={currentCustomer} onCustomerUpdate={handleCustomerUpdate} />
        },
    ] as TabComponentTab[];

    return (
        <Grid>
            <Grid.Col span={{
                base: 12,
                lg: 4
            }}>
                <Stack gap={'xl'}>
                    <InformationPropertyCard record={currentCustomer}/>
                    <ContactInfoPropertyCard record={currentCustomer}/>
                    <BillingInfoPropertyCard record={currentCustomer}/>
                    <MetadataPropertyCard record={currentCustomer}/>
                </Stack>
            </Grid.Col>
            <Grid.Col span={{
                base: 12,
                lg: 8
            }}>
                <TabbedComponent tabs={tabs}/>
            </Grid.Col>
        </Grid>
    );


};
